import React, { useState, useEffect } from "react";

const AlertWindow = ({ message, openAlert, setOpenAlert }) => {
  const [visible, setVisible] = useState(false);

  // useEffect(() => {
  //   if (visible === true) {
  //     const timer = setTimeout(() => {
  //       setVisible(false);
  //       setOpenAlert(false)
  //     }, 3000);

  //     return () => clearTimeout(timer);
  //   }
  // }, [visible]); // eslint-disable-line

  const handleClose = () => {
    setVisible(false);
    setOpenAlert(false)
  };

  useEffect(() => {
    if (openAlert === true) {
      setVisible(true)
    }
  }, [openAlert])

  if (!visible) return null;

  return (
    <div className="fixed inset-0 z-99 flex items-center justify-center bg-gray-900/50">
      <div class="relative px-4 py-3 text-red-800 rounded-lg bg-red-50" role="alert">
        <button 
          onClick={handleClose} 
          className="absolute top-3 right-4 text-xl font-bold"
          aria-label="Close"
        >
          ×
        </button>
        <p className="font-bold text-xl text-start">Reminder</p>
        <p className="text-sm">{message}</p>
      </div>

    </div>


  );
};

export default AlertWindow;
